export const CUISINES = [
  { id: "all", label: "All" },
  { id: "shawarma", label: "Shawarma" },
  { id: "biryani", label: "Biryani" },
  { id: "kebab", label: "Kebab" },
  { id: "burger", label: "Burgers" },
  { id: "pizza", label: "Pizza" },
  { id: "indian", label: "Indian" },
  { id: "pakistani", label: "Pakistani" },
  { id: "turkish", label: "Turkish" },
  { id: "lebanese", label: "Lebanese" },
  { id: "middle_eastern", label: "Middle Eastern" },
  { id: "chinese", label: "Chinese" },
  { id: "malaysian", label: "Malaysian" },
  { id: "australian", label: "Australian" },
  { id: "western", label: "Western" },
  { id: "fast_food", label: "Fast Food" },
  { id: "fish_seafood", label: "Fish / Seafood" },
  { id: "mediterranean", label: "Mediterranean" },
  { id: "dessert", label: "Dessert" },
  { id: "others", label: "Others" },
];
